export default __webpack_public_path__ + "f601fce61b2157cda5ca10e76d938cf1.png";